<template>
    <div v-if="testSystem">
        <loading loader="dots" :active.sync="isLoading" :is-full-page="true"></loading>

        <page-layout header="Projects" logo="/server/files/images/logo_direct.svg">
            <div class="mb-3">
                <b-button :to="{ path: 'om' }" size="sm" style="height: auto; text-decoration: none;">New</b-button>
            </div>

            <b-table striped :items="data" :fields="tableFields" :filter="filter" thead-tr-class="align-middle" >
                <template slot="uuid" slot-scope="row">
                    <b-link :to="{ name: 'main', params: { cluster, uuid: row.item.uuid } }" title="Show project">
                        {{getName(row.item)}}
                    </b-link>
                </template>
                   
                <template slot="actions" slot-scope="row">
                    <b-link @click="deleteProject(row.item)" href="#" title="Delete" class="mx-1" :id="'uuid'+toID(row.item.uuid)"><i class="far fa-trash-alt"></i></b-link>
                    <b-link v-if="row.item.status!='offen'" @click="reopenProject(row.item)" href="#" title="Reopne" class="mx-1"><i class="fas fa-redo"></i></b-link>
                </template>
            </b-table>
        </page-layout>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import PageLayout from '@/layouts/RegistrationLayout.vue'
    import dataService from '@/services/data'
    import Field from '@/shared/utils/Field'

    export default {
        name: 'ProjectPage',

        components: { PageLayout, Loading },

        data() {
            return {
                testSystem: "true"==process.env.VUE_APP_TEST_SYSTEM,
                data: [],
                isLoading: true,
                filter: '',
                tableFields: [
                    {
                        key: 'uuid',
                        label: 'UUID',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'updatedAt',
                        label: 'Last updated',
                        formatter: 'dateTimeFormatter',
                        sortable: true
                    },
                    {
                        key: 'actions'
                    }
                ]
            };
        },

        computed: {
            ...mapGetters(['config', 'cluster'])
        },

        created: function() {
            this.search();
        }, 

        methods: {

            getName: function (project) {
                var value=Field.getValue("customer.name", project.variables.map);
                return value!=null ? value : project.uuid;
            },

            search: function () {
                
                this.isLoading = true;
                dataService.search(this.cluster).then(data => {
                    this.data=data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    this.showError(error.message);
                })
            },

            deleteProject(project) {
                var name=this.getName(project);

                this.$bvModal.msgBoxConfirm('Are you sure to delete project "'+name+'" ?', {okVariant: 'danger', okTitle: 'YES', cancelTitle: 'NO'}).then(result => {
                    if (result) {
                        dataService.delete(this.cluster, project.uuid).then( () => {
                            this.showInfo("Project '"+name+"' was deleted.");
                            this.search();
                        })
                        .catch(error => {
                            this.showError(error.message);
                        })
                    }
                }).catch(error => {
                    this.showError(error.message);
                })
            },

            reopenProject(project) {
                var name=this.getName(project);

                this.$bvModal.msgBoxConfirm('Are you sure to reopen project "'+name+'" ?', {okVariant: 'danger', okTitle: 'YES', cancelTitle: 'NO'}).then(result => {
                    if (result) {
                        dataService.action(this.cluster, project.uuid, "status", "offen").then( () => {
                            this.showInfo("Project '"+name+"' was reopened.");
                            this.search();
                        })
                        .catch(error => {
                            this.showError(error.message);
                        })
                    }
                }).catch(error => {
                    this.showError(error.message);
                })
            },
        }
    }
</script>

<style lang="scss">
</style>
